import React from 'react';
import { useDispatchUi } from 'context/ui';
import { PlayButton } from 'components/PlayButton';
import { BlackHeading } from '@/components/Views/Heading';
import LargeButton from '@/components/Views/Buttons';
import { Trustbar2 } from "@/components/Trustbar2";
import { ComponentProps } from "@/components/component";
import StructuredText from "@/components/ReusableUI/StructuredText";

interface Props {
    id?: string;
    component?: ComponentProps;
    background?: string;
    className?: string;
    ctaButtonText?: string;
    playButtonClass?: string;
}

const FounderSection2 = ({ id, component, background, className, playButtonClass, ctaButtonText, ...props }: Props) => {
    const dispatch: any = useDispatchUi();
    const { content, contentClassName, heading, smallHeading, subhead, videoLink, gallery } = component;

    return (
        <section id={id} style={{ background }} className='default-py px-4 sm:px-10 '>
            <div className={'founders-panel mx-auto default-max-w px-6 lg:px-10 py-6 relative w-full ' + className}>
                <div className='flex flex-row lg:max-w-[500px] max-w-none'>
                    <div className='flex flex-col'>

                        <div className='flex flex-row ml-[-10px] lg:ml-0 pb-0'>
                            <div className='flex'>
                                <div className='flex relative right-0 top-0 '>
                                    <img className='lg:hidden w-[60px] h-auto m-auto' src='/assets/graphics/lana-avatar.png' alt='Lana Israel' />
                                </div>
                            </div>
                            <div className='flex items-center'>
                                <BlackHeading
                                    className='!text-MuzologyDarkPurple text-[#6E60E6] ml-4 mr-[-10px] lg:mr-0 lg:ml-0 pb-4 mt-4 mb-4 lg:mt-0'
                                >
                                    {heading}
                                </BlackHeading>
                            </div>
                        </div>

                        {smallHeading && <p className='text-xl text-gray-600 font-bold text-left  max-w-[450px] w-full leading-8 mt-1'>
                            {smallHeading}
                        </p>}

                        {subhead && <p className='font-lg text-[#4B5563] font-light text-left  max-w-[650px] w-full leading-6 mt-4 lg:mt-1'>
                            {subhead}
                        </p>}

                        <StructuredText
                            data={content}
                            className={contentClassName}
                        />

                        <div className='lg:max-w-[380px] xl:max-w-none'>
                            <div className='flex flex-col sm:flex-row gap-4 items-center justify-center lg:justify-start my-6 lg:my-4'>
                                <LargeButton
                                    id={id + '-watch-video'}
                                    className='dark-button w-[220px]'
                                    onClick={() => dispatch({ type: 'PLAY_VIDEO', payload: videoLink })}
                                    rightDelta={true}
                                    text={ctaButtonText ?? 'How It Works'}
                                />
                            </div>
                        </div>

                        {gallery && <Trustbar2
                            logos={gallery}
                            className='mt-4 center-on-medium lg:!pr-20 sm:!pl-0'
                            wide={true}
                            mediumImageMaxWidth='50%'
                            phoneImageMaxWidth='50%'
                        />}

                    </div>
                </div>

                <div className='absolute bottom-0 -right-12 lg:w-[70%] h-full hidden lg:flex'>
                    <img id='lana' src='/assets/graphics/lana-portrait2.png' className='absolute bottom-0 right-0 w-full' alt='Lana Israel' />
                    <PlayButton
                        id={id + '-play-button'}
                        className={playButtonClass ?? 'dark-orange-play-btn'}
                        videoLink={videoLink}
                        parentStyle={null}
                        onClick={null}
                    />
                </div>
            </div>
        </section>
    );
};

export default FounderSection2;
